import { isEmptyObject } from "../../../utils/tests";
import { LastAndNextMatchQuery } from '../types';

/**
 * typeguard for LastAndNextMatchQuery
 * @param LastAndNextMatchQuery object passed to transformer
 */
export const isValidTeamLastNextMatch = (obj: LastAndNextMatchQuery): boolean => Boolean(obj?.data?.getLastAndNextMatch && !isEmptyObject(obj.data.getLastAndNextMatch));
